import { QueryClient } from '@tanstack/react-query';
import {
  ehApiErrorResponse,
  ehNaoEncontrado,
  ehProblemDetails,
  ehProibido,
} from './api/utils';

const MAXIMO_TENTATIVAS = 3;

/**
 * Não repete o que uma nova tentativa não muda: 404, 403 e os erros no padrão da API, que são
 * de validação ou de negócio.
 */
export function repetirSeErroTransitorio(tentativas: number, erro: unknown) {
  if (
    ehProblemDetails(erro) &&
    (ehNaoEncontrado(erro.status) || ehProibido(erro.status))
  ) {
    return false;
  }

  if (ehApiErrorResponse(erro)) {
    return false;
  }

  return tentativas < MAXIMO_TENTATIVAS;
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: repetirSeErroTransitorio,
      refetchOnWindowFocus: false,
    },
  },
});
